"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TableRow_1 = require("@mui/material/TableRow");
var styles_1 = require("@mui/material/styles");
var Table_1 = __importDefault(require("@mui/material/Table"));
var TableCell_1 = require("@mui/material/TableCell");
var TableBody_1 = require("@mui/material/TableBody");
var material_1 = require("@mui/material");
var borderStyling = '1px solid #eaeaea';
var StyledTable = (0, styles_1.styled)(Table_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(material_1.tableHeadClasses.root)] = {
            backgroundColor: theme.palette.primary.light,
        },
        _b[".".concat(TableCell_1.tableCellClasses.head)] = {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.main,
            borderTop: borderStyling,
            borderBottom: borderStyling,
            zIndex: 100
        },
        _b[".".concat(TableCell_1.tableCellClasses.head, " span.MuiTableSortLabel-root.Mui-active")] = {
            color: theme.palette.primary.dark,
        },
        _b[".".concat(TableCell_1.tableCellClasses.head, " span.MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon")] = {
            color: theme.palette.primary.dark,
        },
        // make the sortlabels hover color to light primary
        _b[".".concat(TableCell_1.tableCellClasses.head, " span.MuiButtonBase-root.MuiTableSortLabel-root:hover")] = {
            color: theme.palette.primary.dark,
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " td, th")] = {
            fontSize: '14px'
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " th:first-of-type, td:first-of-type")] = {
            paddingLeft: theme.spacing(3)
        },
        _b[".".concat(TableBody_1.tableBodyClasses.root, " > tr:last-of-type td")] = {
            border: 0,
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " .MuiIconButton-colorPrimary svg.MuiSvgIcon-root")] = {
            borderRadius: '0.8em',
            width: '1em',
            height: '1em',
            padding: '0.3em',
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, ":hover .MuiIconButton-colorPrimary svg.MuiSvgIcon-root")] = {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.dark,
            border: borderStyling,
            width: '0.9em',
            height: '0.9em'
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " .MuiIconButton-root")] = {
            padding: '0px'
        },
        _b[".".concat(TableCell_1.tableCellClasses.root, ".word-break")] = {
            maxWidth: 200,
            wordBreak: "break-word",
            overflow: "hidden",
            textOverflow: "ellipsis"
        },
        _b);
});
exports.default = StyledTable;
